import React from "react";
import { IcEscenas } from "./player-components/IconosPlayer";

//abre y cierra el carrusel de escenas
const MenuEscenas = ({ handleClickScenesButton, abierto }) => (
  <div id="menuFlotanteEscenas">
    <button
      type="button"
      className="p360-btn p360-vidrio sixth-step"
      title="Escenas"
      aria-label="Escenas de la experiencia"
      aria-pressed={Boolean(abierto)}
      aria-controls="escenasContainer"
      onClick={() => handleClickScenesButton()}
    >
      <IcEscenas />
    </button>
  </div>
);
export default MenuEscenas;
